export default "__VITE_PUBLIC_ASSET__5b5a69a5__"